import ReactModal from 'react-modal'
import type { ConfirmModalProps } from 'global/types/props'
import { L10N } from 'global/localization'
import { Button } from 'shared/components/button'
import Icon from 'shared/components/icon'

export const ConfirmModal = ({
  title,
  desc,
  showXButton = true,
  showCancelButton = true,
  cancelText = L10N.LABEL.CANCEL,
  confirmText = L10N.LABEL.OK,
  confirmColor,
  open,
  onCancel,
  onConfirm
}: ConfirmModalProps) => (
  <ReactModal
    isOpen={open}
    onRequestClose={onCancel}
    contentLabel={title}
    shouldCloseOnOverlayClick={false}
    closeTimeoutMS={300}
    bodyOpenClassName='modal-open'
    overlayClassName='modal-overlay'
    className='confirm-modal'
  >
    <div className='flex flex-row items-center'>
      <h3 className='flex-1 font-heading font-medium text-lg p-4'>{title}</h3>
      {showXButton && (
        <button className='p-4' type='button' onClick={onCancel}>
          <Icon icon='close' size={20} />
        </button>
      )}
    </div>

    <div className='p-4 pt-0 text-sm'>{desc}</div>

    <div className={`border grid ${showCancelButton ? 'grid-cols-2' : 'grid-cols-1'}`}>
      {showCancelButton && <Button label={cancelText} onClick={onCancel} />}
      <Button label={confirmText} color={confirmColor} onClick={onConfirm ?? onCancel} />
    </div>
  </ReactModal>
)
